export default __webpack_public_path__ + "static/fifth-mobile-2d02e0d9a0f9a33bdc25bcb9c2f9b5b5.mp4";